// S18B-2 — CMS operator shift-log API (OSWC GAP-4).
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "./client";

export interface Shift {
  id: string;
  user_id: string | null;
  operator_name: string;
  started_at: string;
  ended_at: string | null;
  notes: string | null;
}

const shiftsKey = ["cms", "shifts"] as const;

export function useShifts(opts?: { activeOnly?: boolean }) {
  return useQuery({
    queryKey: [...shiftsKey, opts ?? {}],
    queryFn: async () => {
      const qs = opts?.activeOnly ? "?active_only=true" : "";
      const { data } = await api.get<{ items: Shift[] }>(`/api/v1/cms/shifts${qs}`);
      return data.items;
    },
    refetchInterval: 60_000,
  });
}

export function useStartShift() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { operator_name: string; notes?: string }) => {
      const { data } = await api.post<Shift>("/api/v1/cms/shifts", input);
      return data;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: shiftsKey }),
  });
}

export function useEndShift() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const { data } = await api.patch<Shift>(`/api/v1/cms/shifts/${id}`, {
        end: true,
      });
      return data;
    },
    onSuccess: () => void qc.invalidateQueries({ queryKey: shiftsKey }),
  });
}
